import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Checkbox,
  Container,
  FormControlLabel,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import imgAwsAhnlabCloudLogo from 'assets/aws-ahnlab-cloud-logo.svg';
import imgSmartNurseLogoGlobal from 'assets/smart-nurse-logo-global.svg';
import Form from 'components/Form';
import MuiDialog from 'components/MuiDialog';

import theme from 'styles/theme';
import ConfirmButton from './components/ConfirmButton';
import PWConfirmButton from './components/PWConfirmButton';

interface Props {
  errors: { [x: string]: any };
  register: UseFormRegister<FieldValues>;
  onSignUp: () => void;
}

function SignInForm({ errors, register, onSignUp }: Props) {
  const { palette } = useTheme();

  return (
    <Box>
      <Container maxWidth="sm" sx={{ mt: 10, mb: 6 }}>
        <Card
          elevation={1}
          sx={{ borderTop: `solid 8px ${palette.primary.main}` }}
        >
          <CardMedia
            height={120}
            component="img"
            image={imgSmartNurseLogoGlobal}
            sx={{ objectFit: 'contain', mt: 5, mb: 5 }}
          />
          <CardContent
            sx={{ width: '100%', textAlign: 'center', padding: '0 0 40px 0' }}
          >
            <Typography>結合真實患者數據</Typography>
            <Typography sx={{ color: `${theme.palette.primary.main}` }}>
              體驗最優秀的醫院記錄系統！
            </Typography>
          </CardContent>
          <CardContent sx={{ ml: 5, mr: 5 }}>
            <TextField
              fullWidth
              label="電子郵件"
              type="email"
              variant="outlined"
              sx={{ mb: 2.5 }}
              error={Boolean(errors.userEmail)}
              helperText={errors.userEmail?.message}
              {...register('userEmail', {
                required: '請輸入您的電子郵件地址',
              })}
            />
            <Form.Password
              fullWidth
              label="密碼"
              sx={{ mb: 0.25 }}
              error={Boolean(errors.userPassword)}
              helperText={errors.userPassword?.message}
              {...register('userPassword', {
                required: '請輸入您的密碼',
              })}
            />
            <FormControlLabel
              control={<Checkbox defaultChecked {...register('saveEmail')} />}
              label="保存電子郵件"
            />
          </CardContent>
          <CardActions sx={{ ml: 5, mr: 5, pb: 5 }}>
            <Box flex={1} textAlign="center">
              <Button
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                sx={{ mb: 2.5 }}
              >
                登錄
              </Button>
              <Button
                fullWidth
                size="large"
                variant="outlined"
                sx={{ mb: 2.5 }}
                onClick={onSignUp}
              >
                註冊
              </Button>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  justifyContent: 'center',
                }}
              >
                <ConfirmButton title="忘記電子郵件" color={'black'} />
                <Typography sx={{ lineHeight: '28px', fontSize: '12px' }}>
                  {' | '}
                </Typography>
                <PWConfirmButton title="忘記密碼" color={'black'} />
              </Box>

              <Button
                fullWidth
                size="large"
                variant="outlined"
                sx={{ mt: 2.5, mb: 2.5 }}
                onClick={() =>
                  window.open(
                    'https://smartnurse.notion.site/Smart-ENR-1dd72847337280299414e3499df48ad3'
                  )
                }
              >
                SmartENR手冊
              </Button>

              <Typography sx={{ fontSize: '0.8125rem' }}>
                諮詢 : nurse@smartnurse.com
              </Typography>
            </Box>
          </CardActions>

          <CardMedia
            height={28}
            component="img"
            image={imgAwsAhnlabCloudLogo}
            sx={{ objectFit: 'contain', mb: 1 }}
          />
          <Typography fontSize={10} align="center" sx={{ mb: 2 }}>
            Copyright © 2022-2026 DKMediInfo. All rights reserved.
          </Typography>
        </Card>
      </Container>
    </Box>
  );
}

export default SignInForm;
